var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRecovery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.3334C28.2843 13.3334 35 11.0948 35 8.33337C35 5.57195 28.2843 3.33337 20 3.33337C11.7157 3.33337 5 5.57195 5 8.33337C5 11.0948 11.7157 13.3334 20 13.3334Z",
    stroke: "#6B2BD9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00001 20C4.9976 20.9319 5.77658 21.8455 7.24905 22.6377C8.72153 23.4299 10.8289 24.0691 13.3333 24.4833",
    stroke: "#6B2BD9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15.5V8.33337",
    stroke: "#6B2BD9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.33337V31.6667C4.99895 32.7478 6.04921 33.8 7.99333 34.6654C9.93746 35.5308 12.6707 36.1628 15.7833 36.4667",
    stroke: "#6B2BD9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20V26.6667H26.6667",
    stroke: "#6B2BD9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 33.3334C22.7161 34.7326 24.1791 35.7662 25.8486 36.2877C27.5181 36.8092 29.3093 36.7922 30.9686 36.2391C32.6278 35.686 34.071 34.6248 35.0937 33.206C36.1164 31.7871 36.6667 30.0824 36.6667 28.3334C36.6667 26.3443 35.8765 24.4366 34.47 23.0301C33.0634 21.6236 31.1558 20.8334 29.1667 20.8334C26.95 20.8334 24.9333 21.7334 23.4833 23.1834L20 26.6667",
    stroke: "#6B2BD9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecovery);
export default __webpack_public_path__ + "static/media/icon-recovery.77786a7085dbd7c4c0407034d60850bf.svg";
export { ForwardRef as ReactComponent };